import TableReportHelper from "report/helper"

export default async function PSMReportSummary(indicador, visita, tipoName) {
    const h = new TableReportHelper(visita.data)
    const IndicadorClass = indicador.constructor
    const params = visita.cliente.getParams(IndicadorClass, tipoName, indicador.type)

    if (!params) {
        return null
    }

    // Obter todos os apontamentos do indicador
    const apontamentos = visita.getApontamentosByIndicador(indicador)

    // Agregar dados de todos os apontamentos
    let totalTocosAvaliados = 0
    let totalPragasAtacados = {
        'Sphenophorus': 0,
        'Hyponeuma': 0,
        'Migdolus': 0,
        'Cupins': 0,
    }
    let totalPragasEncontradas = {
        'Sphenophorus': 0,
        'Hyponeuma': 0,
        'Migdolus': 0,
        'Cupins': 0,
    }

    // Somar todos os valores dos apontamentos
    apontamentos.forEach(apontamento => {
        const tocosAvaliados = parseFloat(apontamento.tocosAvaliados) || 0
        totalTocosAvaliados += tocosAvaliados

        // Processar coletas de Tocos Atacados
        if (apontamento.coletasTocAt && Array.isArray(apontamento.coletasTocAt)) {
            apontamento.coletasTocAt.forEach(coleta => {
                totalPragasAtacados.Sphenophorus += parseFloat(coleta.pragaSphenophorusTocAt) || 0
                totalPragasAtacados.Hyponeuma += parseFloat(coleta.pragaHyponeumaTocAt) || 0
                totalPragasAtacados.Migdolus += parseFloat(coleta.pragaMigdolusTocAt) || 0
                totalPragasAtacados.Cupins += parseFloat(coleta.pragaCupinsTocAt) || 0
            })
        }

        // Processar coletas de Pragas Encontradas
        if (apontamento.coletasPragEnc && Array.isArray(apontamento.coletasPragEnc)) {
            apontamento.coletasPragEnc.forEach(coleta => {
                totalPragasEncontradas.Sphenophorus += parseFloat(coleta.pragaSphenophorusPragEnc) || 0
                totalPragasEncontradas.Hyponeuma += parseFloat(coleta.pragaHyponeumaPragEnc) || 0
                totalPragasEncontradas.Migdolus += parseFloat(coleta.pragaMigdolusPragEnc) || 0
                totalPragasEncontradas.Cupins += parseFloat(coleta.pragaCupinsPragEnc) || 0
            })
        }
    })

    console.log("totalTocosAvaliados ", totalTocosAvaliados);
    if (totalTocosAvaliados === 0) {
        return null // Não gera summary se não há dados
    }

    // Preparar dados para o gráfico de Tocos Atacados
    const dadosTocosAtacados = []
    let totalAtacados = 0
    let totalTocosAtacadosNumber = 0
    Object.entries(totalPragasAtacados).forEach(([nome, valor]) => {
        if (valor > 0) {
            const percentual = (valor / totalTocosAvaliados) * 100
            totalAtacados += percentual
            totalTocosAtacadosNumber += valor
            dadosTocosAtacados.push({
                groupNameShow: nome,
                media: parseFloat(percentual.toFixed(2))
            })
        }
    })

    if (totalAtacados < 100) {
        dadosTocosAtacados.push({
            groupNameShow: 'Não Atacados',
            media: parseFloat((100 - totalAtacados).toFixed(2))
        })
    }

    // Preparar dados para o gráfico de Pragas Encontradas
    const dadosPragasEncontradas = []
    let totalEncontradas = 0
    let totalPragasEncontradasNumber = 0
    Object.entries(totalPragasEncontradas).forEach(([nome, valor]) => {
        if (valor > 0) {
            const percentual = (valor / totalTocosAvaliados) * 100
            totalEncontradas += percentual
            totalPragasEncontradasNumber += valor
            dadosPragasEncontradas.push({
                groupNameShow: nome,
                media: parseFloat(percentual.toFixed(2))
            })
        }
    })

    if (totalEncontradas < 100) {
        dadosPragasEncontradas.push({
            groupNameShow: 'Não Encontradas',
            media: parseFloat((100 - totalEncontradas).toFixed(2))
        })
    }

    return h.panel([
        h.row(
            h.title(IndicadorClass.fullName, { alignment: "center" }),
        ),
        h.row(
            h.title(`Pragas Encontradas: ${totalPragasEncontradasNumber}`, { alignment: 'center', margin: [0, 10, 0, 5] }),
        ),
        h.row(
            await h.chart(
                "PieChart",
                {
                    xField: "groupNameShow",
                    yField: "media",
                    data: dadosPragasEncontradas,
                    width: 525,
                    height: 150,

                }
            ),
        ),
        h.row(
            h.title(`Tocos Atacados: ${totalTocosAtacadosNumber}`, { alignment: 'center', margin: [0, 10, 0, 5] }),
        ),
        h.row(
            await h.chart(
                "PieChart",
                {
                    xField: "groupNameShow",
                    yField: "media",
                    data: dadosTocosAtacados,
                    width: 525,
                    height: 150,
                }
            ),
        )
    ], { widths: ["*"], unbreakable: true, layout: "borders" })

    // Retornar estrutura customizada apenas com os gráficos
    // return h.panel(
    //     [
    //         h.row(
    //             h.title(IndicadorClass.fullName, { alignment: "center" })
    //         ),
    //         h.row(
    //             h.text('Tocos Atacados', { style: 'h3', alignment: 'center', margin: [0, 10, 0, 5] })
    //         ),
    //         h.row(
    //             imagemAtacados
    //         ),
    //         h.row(
    //             h.text('Pragas Encontradas', { style: 'h3', alignment: 'center', margin: [0, 10, 0, 5] })
    //         ),
    //         h.row(
    //             imagemEncontradas
    //         )
    //     ],
    //     { widths: ["*"], unbreakable: true, layout: "borders" }
    // )
}
